<template>
  <div>
    <div class="container sm:px-10">
      <div class="block xl:grid grid-cols-2 gap-4">
        <div class="hidden xl:flex flex-col min-h-screen">
          <a href="" class="-intro-x flex items-center pt-5">
            <!-- <img :src="imgLogo" alt="" class="w-6" style="width: 100px;" /> -->
            <span class="text-white text-lg ml-3">WORKFLOW</span>
          </a>
          <div class="my-auto">
            <!-- <div class="bg-white p-5 ">
              <img
                :src="require(`@/assets/images/aqatop1_08.jpeg`)"
                alt=""
                class="-intro-x w-1/2"
              />
            </div> -->
            <div
              class="
                -intro-x
                text-white
                font-medium
                text-4xl
                leading-tight
              "
            >
              WORKFLOW
            </div>
            <div
              class="
                -intro-x
                mt-5
                text-lg text-white text-opacity-70
                dark:text-gray-500
              "
            >
              Manage all your company in one place
            </div>
          </div>
        </div>
        <div class="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
          <div
            class="
              bg-white
              my-auto
              mx-auto
              px-10
              pb-5
              rounded-md
              shadow-md
              w-full
              md:w-3/4
              lg:w-2/4
            "
          >
            <div class="py-10 flex justify-center">
              <img :src="imgLogo" alt="Aqua Logo" class="-intro-x w-75" />
            </div>
            <h2
              class="
                intro-x
                font-bold
                text-2xl
                xl:text-3xl
                text-center
                xl:text-left
              "
            >
              Sign In
            </h2>
            <div
              class="
                alert alert-outline-danger alert-dismissible
                show
                flex
                items-center
                mt-5
              "
              role="alert"
              v-if="noti.type"
            >
              <AlertOctagonIcon class="w-6 h-6 mr-2" /> {{ noti.message }}
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              >
                <XIcon class="w-4 h-4" />
              </button>
            </div>
            <form method="post" @submit.prevent>
              <div class="intro-x mt-8">
                <input
                  type="text"
                  placeholder="Email or Account"
                  v-model="email"
                  autofocus
                  autocomplete
                  class="
                    intro-x
                    login__input
                    form-control
                    py-3
                    px-4
                    border-gray-300
                    block
                  "
                />
                <input
                  type="password"
                  placeholder="Password"
                  autocomplete
                  v-model="pass"
                  class="
                    intro-x
                    login__input
                    form-control
                    py-3
                    px-4
                    border-gray-300
                    block
                    mt-4
                  "
                />
              </div>
              <div
                class="
                  intro-x
                  flex
                  text-gray-700
                  dark:text-gray-600
                  text-xs
                  sm:text-sm
                  mt-4
                "
              >
                <!-- <div class="flex items-center mr-auto">
                  <input
                    type="checkbox"
                    class="form-check-input border mr-2"
                    id="remember-me"
                  />
                  <label for="remember-me" class="cursor-pointer select-none"
                    >Remember me
                  </label>
                </div> -->
              </div>
              <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
                <button
                  class="btn btn-primary py-3 xl:w-32 xl:mr-3 align-top disabled:opacity-50"
                  @click="login"
                  :disabled="isLogin"
                >
                  <LoadingIcon
                    icon="oval"
                    v-show="isLogin"
                    color="white"
                    class="w-4 h-4 mr-2"
                  />
                  Login
                </button>
                <!-- 112901 worrapoj_pho 113010 aroon_law 113201 suwipha_bus -->
              </div>
            </form>
            <div class="mt-10 flex justify-between">
              <div
                class="
                  intro-x
                  text-gray-700
                  dark:text-gray-600
                "
              >
                By Nation Group<br />
                <a class="text-blue-400" href="/privacy-policy"
                  >นโยบายคุ้มครองข้อมูลส่วนบุคคล</a
                >
              </div>
              <div
                class="
                  intro-x
                  text-gray-700
                  dark:text-gray-600
                "
              >
                Version 2.2.2
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, computed, ref } from 'vue'
import { useStore } from '@/store'
export default defineComponent({
  setup() {
    const store = useStore()
    const imgLogo = ref(process.env.VUE_APP_IMAGE_LOGO)
    const email = ref('')
    const pass = ref('')
    const login = () => {
      store.dispatch('auth/login', {
        email: email.value,
        password: pass.value
      })
    }

    const noti = computed(() => store.state.notification)
    const isLogin = computed(() => store.state.auth.loginRequire)

    // console.log('env: ', process.env)
    onMounted(() => {
      cash('body')
        .removeClass('main')
        .removeClass('error-page')
      // .addClass('login')
      // store.dispatch('global/loadCompanyDefault')
    })

    return {
      email,
      pass,
      isLogin,
      login,
      noti,
      imgLogo
    }
  }
})
</script>
